import { Button, Input, Radio, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { StyledLabel } from '@/components/main/graph/modal/style'
import { useRedis } from '@/hooks/useRedis'
import {
  clearSearchFilters,
  GolfSearchState,
  initialSearchState,
  setAreaCountMap,
  setSearchParams,
} from '@/redux/slices/golfSearchSlice'
import { RootState } from '@/redux/store'
import { useEffect, useState } from 'react'
import { X } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { useGolfSearchData } from './useGolfSearchData'
import { useAxios } from '@/context/axiosContext'
import { useResponsive } from '@/hooks/useResponsive'
import 'pages/golf/detailSearch/detailSearch.css'
import { StatusType } from '@/pages/promotion/promotionItem'
interface MainGolfSearchFilterProps {
  filters: GolfSearchState
  updateFilter: (
    key: keyof GolfSearchState,
    value: string | number | null,
  ) => void
}

export const MainGolfSearchFilter = () => {
  // const { data } = useGolfSearchData()
  const data = useSelector(
    (state: RootState) => state.golfSearch.golfListData.listData,
  )
  const dispatch = useDispatch()
  const location = useLocation()

  const axios = useAxios()

  const { getComCodes } = useRedis()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [areaCd, setAreaCd] = useState<string>('')

  const areaCountMap = useSelector(
    (state: RootState) => state.golfSearch.areaCountMap,
  )

  const [countArea, setCountArea] = useState(areaCountMap)

  const searchParams = useSelector(
    (state: RootState) => state.golfSearch.searchParams,
  )

  const [filters, setFilters] = useState<GolfSearchState>({
    bizNm: searchParams.bizNm,
    minPrice: searchParams.minPrice,
    maxPrice: searchParams.maxPrice,
    areaCd: searchParams.areaCd,
    dayType: searchParams.dayType,
    months: searchParams.months,
    membershipYn: searchParams.membershipYn,
    holeType: searchParams.holeType,
    confidenceLvlCd: searchParams.confidenceLvlCd,
  })

  const { isMobile, isTablet, isDesktop } = useResponsive()
  // const [areaCountMap, setAreaCountMap] = useState<{ [key: string]: number }>(
  //   {},
  // )

  useEffect(() => {
    if (data.length > 0 && totalCount === 0) {
      setTotalCount(data.length) // 최초 데이터 길이 설정
    }
  }, [data])

  useEffect(() => {
    const isFromNationwide = localStorage.getItem('isNationwide') === 'true'
    //console.log('isFromNationwide', isFromNationwide)

    if (isFromNationwide) {
      dispatch(
        setSearchParams({
          ...searchParams,
          areaCd: '',
        }),
      )
      // UI 필터도 전국(00)으로 설정
      updateFilter('areaCd', '00')
      // 사용 후 삭제
      localStorage.removeItem('isNationwide')
    }
  }, [])

  // useEffect(() => {
  //   if (filters.areaCd !== undefined) {
  //     // areaCd가 설정되었을 때만 호출
  //     handleSearchClick()
  //   }
  // }, [filters.areaCd])

  // useEffect(() => {
  //   const prevPage = localStorage.getItem('prevPage')
  //   const prevAreaCode = localStorage.getItem('prevAreaCode')

  //   if (location.pathname === '/main' || location.pathname === '/') {
  //     if (prevPage === 'detailInfo' && prevAreaCode) {
  //       // detail → main 복귀: 이전 지역 필터 유지
  //       localStorage.removeItem('prevPage')
  //       localStorage.removeItem('prevAreaCode')

  //       const restoredFilter = {
  //         ...initialSearchState,
  //         areaCd: prevAreaCode, // 저장된 지역 코드로 복원
  //       }

  //       // 필터 상태가 있다면 setFilters 호출, 없다면 Redux만 업데이트
  //       if (typeof setFilters === 'function') {
  //         setFilters(restoredFilter)
  //       }
  //       dispatch(clearSearchFilters())
  //       dispatch(setSearchParams(restoredFilter))
  //     } else {
  //       // 새로 진입: 전국 초기화
  //       setTimeout(() => {
  //         if (typeof setFilters === 'function') {
  //           setFilters(initialSearchState)
  //         }
  //         dispatch(clearSearchFilters())
  //         dispatch(setSearchParams(initialSearchState))
  //       }, 100)
  //     }
  //   }
  // }, [location, dispatch])

  // useEffect(() => {
  //   const prevPage = localStorage.getItem('prevPage')
  //   const prevAreaCode = localStorage.getItem('prevAreaCode')
  //   const prevIsNationwide = localStorage.getItem('prevIsNationwide') === 'true' // 추가

  //   if (location.pathname === '/main' || location.pathname === '/') {
  //     if (prevPage === 'detailInfo' && prevAreaCode !== null) {
  //       localStorage.removeItem('prevPage')
  //       localStorage.removeItem('prevAreaCode')
  //       localStorage.removeItem('prevIsNationwide') // 추가

  //       if (prevIsNationwide) {
  //         // 전국이었다면 완전 초기화
  //         setFilters(initialSearchState)
  //         dispatch(setSearchParams(initialSearchState))
  //       } else {
  //         // 특정 지역이었다면 복원
  //         const restoredFilter = { ...initialSearchState, areaCd: prevAreaCode }
  //         setFilters(restoredFilter)
  //         dispatch(setSearchParams(restoredFilter))
  //       }
  //     } else {
  //       // 새로 진입: 전국 초기화
  //       setTimeout(() => {
  //         if (typeof setFilters === 'function') {
  //           setFilters(initialSearchState)
  //         }
  //         dispatch(clearSearchFilters())
  //         dispatch(setSearchParams(initialSearchState))
  //       }, 100)
  //     }
  //   }
  // }, [location, dispatch])

  useEffect(() => {
    const prevPage = localStorage.getItem('prevPage')
    const prevAreaCode = localStorage.getItem('prevAreaCode')
    const prevIsNationwide = localStorage.getItem('prevIsNationwide') === 'true'

    if (location.pathname === '/main' || location.pathname === '/') {
      if (prevPage === 'detailInfo' && prevAreaCode !== null) {
        localStorage.removeItem('prevPage')
        localStorage.removeItem('prevAreaCode')
        localStorage.removeItem('prevIsNationwide')

        if (prevIsNationwide) {
          // 전국에서 온 경우 - 완전 초기화 (areaCd를 '' 로)
          // console.log('전국에서 왔으므로 areaCd 초기화')
          const restoredFilter = {
            ...initialSearchState,
            areaCd: '', // 전국으로 초기화
          }
          setFilters(restoredFilter)
          dispatch(setSearchParams(restoredFilter))
        } else {
          // 특정 지역에서 온 경우 - 해당 지역으로 복원
          //console.log('특정 지역에서 왔으므로 지역 복원:', prevAreaCode)
          const restoredFilter = {
            ...initialSearchState,
            areaCd: prevAreaCode, // 원래 지역으로 복원
          }
          setFilters(restoredFilter)
          dispatch(setSearchParams(restoredFilter))
        }
      } else {
        // 새로 진입하는 경우
        setTimeout(() => {
          setFilters(initialSearchState)
          dispatch(clearSearchFilters())
          dispatch(setSearchParams(initialSearchState))
        }, 100)
      }
    }
  }, [location, dispatch])

  const updateFilter = (
    key: keyof GolfSearchState,
    value: string | number | null,
  ) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }))
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      //console.log('엔터 입력 - 검색 실행', filters)
      handleSearchClick()
    }
  }

  const handleSearchClick = () => {
    // areaCd가 빈 값이 아니면 검색 시작
    dispatch(
      setSearchParams({
        ...filters,
        _timestamp: Date.now(),
      }),
    )
  }

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState)
  }

  const getCountByAreaCd = async () => {
    const response = await axios.get('/golf/countByAreaCd', {})
    if (response.status == 200) {
      const countByAreaCdMap = response.data.data.countMap
      setCountArea(countByAreaCdMap)
      dispatch(setAreaCountMap(countByAreaCdMap))
    }
  }

  useEffect(() => {
    if (Object.keys(areaCountMap).length === 0) {
      getCountByAreaCd()
    }
  }, [data])

  /*  //2025.03.19 ljh 정보제공 목적으로 로그인 후 이용 옵션 제거
  const handleConfirm = () => {
    let msg =
      '로그인 후 골프장검색 메뉴에서 이용할 수 있는 옵션이에요. 로그인화면으로 이동할까요?'
    if (isAuthenticated)
      msg =
        '골프장검색 메뉴에서 이용할 수 있는 옵션이에요. 해당메뉴로 이동할까요?'

    showConfirm({
      title: msg,
      onConfirm() {
        if (isAuthenticated) {
          navigate('/golf/detailSearch')
        } else {
          navigate('/login', {
            state: {
              redirectTo: '/golf/detailSearch',
            },
          })
        }
      },
    })
  }
*/
  return (
    <>
      {!isMobile ? (
        <form>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              marginTop: '1px',
              marginBottom: '20px',
              justifyContent: 'flex-start', // 왼쪽 정렬
            }}
          >
            {getComCodes('AREA_CD').map((item) => {
              const areaCount = countArea[item.code] || 0 // 기본값 0
              return (
                <Button
                  key={item.code}
                  variant={
                    (filters.areaCd && filters.areaCd == item.code) ||
                    (item.code == '00' && !filters.areaCd)
                      ? 'contained'
                      : 'outlined'
                  }
                  color="neverbe"
                  size="sm"
                  borderRadius="20px"
                  active={areaCd === item.code}
                  // onClick={() => {
                  //   updateFilter('areaCd', item.code === '00' ? '' : item.code)
                  //   dispatch(
                  //     setSearchParams({
                  //       ...filters,
                  //       areaCd: item.code === '00' ? '' : item.code,
                  //       _timestamp: Date.now(),
                  //     }),
                  //   )
                  // }}
                  onClick={() => {
                    const isNationwideClick = item.code === '00'
                    updateFilter('areaCd', item.code === '00' ? '' : item.code)
                    dispatch(
                      setSearchParams({
                        ...filters,
                        areaCd: item.code === '00' ? '' : item.code,
                        isNationwide: isNationwideClick, // 이 줄만 추가
                        _timestamp: Date.now(),
                      }),
                    )
                  }}
                >
                  {item.remark} ({areaCount})
                </Button>
              )
            })}
          </div>
          {/* <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              width: '100%',
            }}
          >
            <StyledLabel style={{ minWidth: '30px' }}>홀 타입</StyledLabel>
            <Select
              name="holeType"
              id="holeType"
              onChange={(e) => updateFilter('holeType', e.target.value)}
              width="100px"
              value={filters.holeType}
            >
              <option value="">전체</option>
              {getComCodes('HOLE_TYPE').map((code: any) => (
                <option key={'holeType' + code.code} value={code.code}>
                  {code.codeNm}
                </option>
              ))}
            </Select>

            <div style={{ width: '10px' }}></div>

            <StyledLabel style={{ minWidth: '30px' }}>정확도</StyledLabel>
            <Select
              name="confidenceLvlCd"
              id="confidenceLvlCd"
              onChange={(e) => updateFilter('confidenceLvlCd', e.target.value)}
              width="100px"
              value={filters.confidenceLvlCd}
            >
              <option value="">전체</option>
              {getComCodes('CONFIDENCE_LVL_CD').map((code: any) => (
                <option key={'confidenceLvlCd' + code.code} value={code.code}>
                  {code.codeNm}
                </option>
              ))}
            </Select>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flex: 1,
                position: 'relative',
              }}
            >
              <StyledLabel style={{ minWidth: '30px' }}>골프장명</StyledLabel>
              <Input
                type="text"
                id="searchKeyword"
                name="searchKeyword"
                placeholder="골프장명을 입력해주세요."
                value={filters.bizNm || ''}
                onChange={(e) => updateFilter('bizNm', e.target.value)}
                onKeyDown={handleKeyDown}
                maxLength={100}
                style={{ width: '100%', paddingRight: '30px' }}
              />
              {filters.bizNm && (
                <X
                  onClick={() => updateFilter('bizNm', null)}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    width: '20px',
                    height: '20px',
                  }}
                />
              )}
            </div> 
          </div>*/}

          {/* <div style={{ flex: 1 }}>
          <StyledLabel htmlFor="region">지역</StyledLabel>
          <Select
            id="region"
            name="region"
            value={filters.areaCd || ''}
            onChange={(e) => updateFilter('areaCd', e.target.value)}
          >
            {regions.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
          </Select>
        </div> */}

          {/* <>
            <FlexWrapper
              gap="40px"
              style={{
                marginTop: '10px',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <FlexWrapper style={{ alignItems: 'center', flex: 1 }}>
                <StyledLabel style={{ minWidth: '30px', marginRight: '10px' }}>
                  요금 구분
                </StyledLabel>
                <FlexWrapper>
                  <Radio
                    id="weekday"
                    name="dayType"
                    value="weekday"
                    checked={filters.dayType === 'weekday'}
                    onChange={(e) => updateFilter('dayType', e.target.value)}
                    readonly={true}
                    onMouseDown={(e) => e.preventDefault()}
                    label="주중"
                  />
                  <Radio
                    id="weekend"
                    name="dayType"
                    value="weekend"
                    checked={filters.dayType === 'weekend'}
                    onChange={(e) => updateFilter('dayType', e.target.value)}
                    onMouseDown={(e) => e.preventDefault()}
                    label="주말"
                  />
                  <InputRow style={{ marginLeft: '10px' }}>
                    <Input
                      id="greenFeeMin"
                      name="greenFeeMin"
                      type="number"
                      placeholder="최소 금액"
                      value={filters.minPrice || ''}
                      onChange={(e) =>
                        updateFilter(
                          'minPrice',
                          e.target.value ? Number(e.target.value) : null,
                        )
                      }
                      onKeyDown={handleKeyDown}
                      maxLength={6}
                      step={10000}
                    />
                    <span>~</span>
                    <Input
                      id="greenFeeMax"
                      name="greenFeeMax"
                      type="number"
                      placeholder="최대 금액"
                      value={filters.maxPrice || ''}
                      onChange={(e) =>
                        updateFilter(
                          'maxPrice',
                          e.target.value ? Number(e.target.value) : null,
                        )
                      }
                      onKeyDown={handleKeyDown}
                      maxLength={6}
                      step={10000}
                    />
                  </InputRow>
                </FlexWrapper>
              </FlexWrapper>

              <FlexWrapper style={{ alignItems: 'center' }}>
                <StyledLabel style={{ minWidth: '30px', marginRight: '10px' }}>
                  회원제 구분
                </StyledLabel>
                <FlexWrapper>
                  <Radio
                    id="membershipA"
                    name="membershipYn"
                    value="A"
                    checked={filters.membershipYn === 'A'}
                    onChange={(e) =>
                      updateFilter('membershipYn', e.target.value)
                    }
                    label="전체"
                    onMouseDown={(e) => e.preventDefault()}
                  />
                  <Radio
                    id="membershipY"
                    name="membershipYn"
                    value="Y"
                    checked={filters.membershipYn === 'Y'}
                    onChange={(e) =>
                      updateFilter('membershipYn', e.target.value)
                    }
                    label="회원제"
                    onMouseDown={(e) => e.preventDefault()}
                  />
                  <Radio
                    id="membershipN"
                    name="membershipYn"
                    value="N"
                    checked={filters.membershipYn === 'N'}
                    onChange={(e) =>
                      updateFilter('membershipYn', e.target.value)
                    }
                    label="비회원제"
                    onMouseDown={(e) => e.preventDefault()}
                  />
                  <div style={{ marginLeft: '10px' }} />
                  <Button color="neverbe" onClick={handleSearchClick}>
                    검색
                  </Button>
                </FlexWrapper>
              </FlexWrapper>
            </FlexWrapper>
          </> */}

          <section
            className="detail-search-section"
            style={{ marginTop: '10px' }}
          >
            <div className="detail-search-row">
              <div className="detail-search-web-select-group">
                <label>홀 타입</label>
                <select
                  className="detail-search-custom-select"
                  name="holeType"
                  id="holeType"
                  style={{ width: '200px' }}
                  onChange={(e) => updateFilter('holeType', e.target.value)}
                  value={filters.holeType}
                >
                  <option value="">전체</option>
                  {getComCodes('HOLE_TYPE').map((code: any) => (
                    <option key={'holeType' + code.code} value={code.code}>
                      {code.codeNm}
                    </option>
                  ))}
                </select>
              </div>
              <div className="detail-search-web-select-group">
                <label>정확도</label>
                <select
                  className="detail-search-custom-select"
                  name="confidenceLvlCd"
                  id="confidenceLvlCd"
                  style={{ width: '200px' }}
                  onChange={(e) =>
                    updateFilter('confidenceLvlCd', e.target.value)
                  }
                  value={filters.confidenceLvlCd}
                >
                  <option value="">전체</option>
                  {getComCodes('CONFIDENCE_LVL_CD').map((code: any) => (
                    <option
                      key={'confidenceLvlCd' + code.code}
                      value={code.code}
                    >
                      {code.codeNm}
                    </option>
                  ))}
                </select>
              </div>
              <div className="detail-search-input-group">
                <label>골프장명</label>
                <input
                  type="text"
                  className="detail-search-input"
                  placeholder="골프장명을 입력해주세요"
                  id="searchKeyword"
                  name="searchKeyword"
                  value={filters.bizNm || ''}
                  onChange={(e) => updateFilter('bizNm', e.target.value)}
                  onKeyDown={handleKeyDown}
                  maxLength={100}
                />
              </div>
            </div>

            <div className="detail-search-row">
              <div
                className="detail-search-radio-group"
                style={{ marginBottom: '10px' }}
              >
                <input
                  type="radio"
                  id="weekday"
                  name="dayType"
                  value="weekday"
                  checked={filters.dayType === 'weekday'}
                  onChange={(e) => updateFilter('dayType', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                주중
                <input
                  type="radio"
                  id="weekend"
                  name="dayType"
                  value="weekend"
                  checked={filters.dayType === 'weekend'}
                  onChange={(e) => updateFilter('dayType', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                주말
              </div>

              <div className="detail-search-price-inputs">
                <input
                  type="number"
                  className="detail-search-price-input"
                  placeholder="최소 금액"
                  id="greenFeeMin"
                  name="greenFeeMin"
                  value={filters.minPrice || ''}
                  onChange={(e) =>
                    updateFilter(
                      'minPrice',
                      e.target.value ? Number(e.target.value) : null,
                    )
                  }
                  onKeyDown={handleKeyDown}
                  maxLength={6}
                  step={10000}
                />
                <span className="detail-search-price-divider">~</span>
                <input
                  type="number"
                  className="detail-search-price-input"
                  placeholder="최대 금액"
                  id="greenFeeMax"
                  name="greenFeeMax"
                  value={filters.maxPrice || ''}
                  onChange={(e) =>
                    updateFilter(
                      'maxPrice',
                      e.target.value ? Number(e.target.value) : null,
                    )
                  }
                  onKeyDown={handleKeyDown}
                  maxLength={6}
                  step={10000}
                />
              </div>
              <div
                className="detail-search-radio-group"
                style={{ marginBottom: '10px' }}
              >
                <input
                  type="radio"
                  id="membershipA"
                  name="membershipYn"
                  value="A"
                  checked={filters.membershipYn === 'A'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                전체
                <input
                  type="radio"
                  id="membershipY"
                  name="membershipYn"
                  value="Y"
                  checked={filters.membershipYn === 'Y'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                회원제
                <input
                  type="radio"
                  id="membershipN"
                  name="membershipYn"
                  value="N"
                  checked={filters.membershipYn === 'N'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                비회원제
              </div>
              <button
                className="detail-search-btn"
                onClick={handleSearchClick}
                style={{ width: '120px' }}
              >
                검색
              </button>
            </div>
          </section>
        </form>
      ) : (
        <>
          <section className="detail-search-region-section">
            {/* <div className="detail-search-region-grid">
              <button className="detail-search-region-btn active">
                전국 (566)
              </button>
              <button className="detail-search-region-btn">서울 (2)</button>
            </div> */}
            <div className="detail-search-region-grid">
              {getComCodes('AREA_CD').map((item) => {
                const areaCount = countArea[item.code] || 0 // 기본값 0
                return (
                  <Button
                    key={item.code}
                    variant={
                      (filters.areaCd && filters.areaCd == item.code) ||
                      (item.code == '00' && !filters.areaCd)
                        ? 'contained'
                        : 'outlined'
                    }
                    color="neverbe"
                    size="sm"
                    borderRadius="20px"
                    active={areaCd === item.code}
                    onClick={() => {
                      updateFilter(
                        'areaCd',
                        item.code === '00' ? '' : item.code,
                      )
                      dispatch(
                        setSearchParams({
                          ...filters,
                          areaCd: item.code === '00' ? '' : item.code,
                          _timestamp: Date.now(),
                        }),
                      )
                    }}
                  >
                    {item.remark} ({areaCount})
                  </Button>
                )
              })}
            </div>
          </section>

          <section className="detail-search-section">
            <div className="detail-search-row">
              <div className="detail-search-select-group">
                <label>홀 타입</label>
                <select
                  className="detail-search-custom-select"
                  name="holeType"
                  id="holeType"
                  onChange={(e) => updateFilter('holeType', e.target.value)}
                  value={filters.holeType}
                >
                  <option value="">전체</option>
                  {getComCodes('HOLE_TYPE').map((code: any) => (
                    <option key={'holeType' + code.code} value={code.code}>
                      {code.codeNm}
                    </option>
                  ))}
                </select>
              </div>
              <div className="detail-search-select-group">
                <label>정확도</label>
                <select
                  className="detail-search-custom-select"
                  name="confidenceLvlCd"
                  id="confidenceLvlCd"
                  onChange={(e) =>
                    updateFilter('confidenceLvlCd', e.target.value)
                  }
                  value={filters.confidenceLvlCd}
                >
                  <option value="">전체</option>
                  {getComCodes('CONFIDENCE_LVL_CD').map((code: any) => (
                    <option
                      key={'confidenceLvlCd' + code.code}
                      value={code.code}
                    >
                      {code.codeNm}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="detail-search-row">
              <div className="detail-search-input-group">
                <label>골프장명</label>
                <input
                  type="text"
                  className="detail-search-input"
                  placeholder="골프장명을 입력해주세요"
                  id="searchKeyword"
                  name="searchKeyword"
                  value={filters.bizNm || ''}
                  onChange={(e) => updateFilter('bizNm', e.target.value)}
                  onKeyDown={handleKeyDown}
                  maxLength={100}
                />
              </div>
            </div>

            <div className="detail-search-row">
              <div className="detail-search-radio-group">
                <input
                  type="radio"
                  id="weekday"
                  name="dayType"
                  value="weekday"
                  checked={filters.dayType === 'weekday'}
                  onChange={(e) => updateFilter('dayType', e.target.value)}
                  //readOnly={true}
                  onMouseDown={(e) => e.preventDefault()}
                />
                주중
                <input
                  type="radio"
                  id="weekend"
                  name="dayType"
                  value="weekend"
                  checked={filters.dayType === 'weekend'}
                  onChange={(e) => updateFilter('dayType', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                주말
              </div>

              <div className="detail-search-price-range">
                <div className="detail-search-price-inputs">
                  <input
                    type="number"
                    className="detail-search-price-input"
                    placeholder="최소 금액"
                    id="greenFeeMin"
                    name="greenFeeMin"
                    value={filters.minPrice || ''}
                    onChange={(e) =>
                      updateFilter(
                        'minPrice',
                        e.target.value ? Number(e.target.value) : null,
                      )
                    }
                    onKeyDown={handleKeyDown}
                    maxLength={6}
                    step={10000}
                  />
                  <span className="detail-search-price-divider">~</span>
                  <input
                    type="number"
                    className="detail-search-price-input"
                    placeholder="최대 금액"
                    id="greenFeeMax"
                    name="greenFeeMax"
                    value={filters.maxPrice || ''}
                    onChange={(e) =>
                      updateFilter(
                        'maxPrice',
                        e.target.value ? Number(e.target.value) : null,
                      )
                    }
                    onKeyDown={handleKeyDown}
                    maxLength={6}
                    step={10000}
                  />
                </div>
              </div>
            </div>

            <div className="detail-search-row">
              <div className="detail-search-radio-group">
                <input
                  type="radio"
                  id="membershipA"
                  name="membershipYn"
                  value="A"
                  checked={filters.membershipYn === 'A'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                전체
                <input
                  type="radio"
                  id="membershipY"
                  name="membershipYn"
                  value="Y"
                  checked={filters.membershipYn === 'Y'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                회원제
                <input
                  type="radio"
                  id="membershipN"
                  name="membershipYn"
                  value="N"
                  checked={filters.membershipYn === 'N'}
                  onChange={(e) => updateFilter('membershipYn', e.target.value)}
                  onMouseDown={(e) => e.preventDefault()}
                />
                비회원제
              </div>
              <button className="detail-search-btn" onClick={handleSearchClick}>
                검색
              </button>
            </div>
          </section>
        </>
      )}
    </>
  )
}

const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    width: 100%;
  }

  span {
    margin: 0 5px;
  }
`
